module.exports = __webpack_public_path__ + "img/perfumesImage.04ed6a26.svg";